<div class="checkout-group">
  <div class="checkout-group-title">
    {{ 'checkout.group.billing.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body">
    <div class="address-group">
      <span class="address-label">{{ 'checkout.group.billing.addressLabel' | cxTranslate }}</span>
      <span
        class="address-value"
        *ngIf="this.currentDeliveryAddress"
        [innerHTML]="showAddress(this.currentDeliveryAddress) | async"
      ></span>
    </div>
  </div>
</div>
